/**
 * Typography Scale
 *
 * Градация размеров:
 * ──────────────────────────────────────────────────────────
 * h1      │ 3.5rem  (56px) │ Заголовки страниц
 * h2      │ 3rem    (48px) │ Заголовки секций
 * h3      │ 2.25rem (36px) │ Подзаголовки
 * h4      │ 1.75rem (28px) │ Заголовки карточек
 * h5      │ 1.5rem  (24px) │ Мелкие заголовки
 * h6      │ 1.25rem (20px) │ Самые мелкие заголовки
 * ──────────────────────────────────────────────────────────
 * body1   │ 1.25rem (20px) │ Основной текст
 * body2   │ 1.125rem(18px) │ Вторичный текст
 * ──────────────────────────────────────────────────────────
 * subtitle1 │ 1.5rem (24px) │ Подзаголовки (жирный)
 * subtitle2 │ 1.125rem(18px)│ Мелкие подзаголовки
 * ──────────────────────────────────────────────────────────
 * caption │ 1rem    (16px) │ Подписи, метки
 * overline│ 1rem    (16px) │ Надписи сверху (UPPERCASE)
 * button  │ 1.125rem(18px) │ Текст кнопок
 * ──────────────────────────────────────────────────────────
 * tableHeader │ 1.125rem(18px) │ Заголовки таблиц
 * tableCell   │ 1rem    (16px) │ Ячейки таблиц
 * ──────────────────────────────────────────────────────────
 * badge       │ 0.8125rem(13px) │ Текст в бейджах
 * badgeSmall  │ 0.6875rem(11px) │ Мелкие бейджи
 * ──────────────────────────────────────────────────────────
 * iconSizes:
 *   xs  │ 1rem     (16px)
 *   sm  │ 1.25rem  (20px)
 *   md  │ 1.5rem   (24px)
 *   lg  │ 2rem     (32px)
 *   xl  │ 3rem     (48px)
 *   xxl │ 4rem     (64px)
 * ──────────────────────────────────────────────────────────
 */

const fontFamily = "'Plus Jakarta Sans', sans-serif";

const typography = {
  fontFamily,

  // Заголовки (headings)
  h1: {
    fontFamily,
    fontWeight: 700,
    fontSize: '3.5rem',
    lineHeight: 1.2,
  },
  h2: {
    fontFamily,
    fontWeight: 600,
    fontSize: '3rem',
    lineHeight: 1.2,
  },
  h3: {
    fontFamily,
    fontWeight: 600,
    fontSize: '2.25rem',
    lineHeight: 1.3,
  },
  h4: {
    fontFamily,
    fontWeight: 600,
    fontSize: '1.75rem',
    lineHeight: 1.3,
  },
  h5: {
    fontFamily,
    fontWeight: 600,
    fontSize: '1.5rem',
    lineHeight: 1.4,
  },
  h6: {
    fontFamily,
    fontWeight: 600,
    fontSize: '1.25rem',
    lineHeight: 1.4,
  },

  // Основной текст (body)
  body1: {
    fontFamily,
    fontWeight: 400,
    fontSize: '1.25rem',
    lineHeight: 1.5,
  },
  body2: {
    fontFamily,
    fontWeight: 400,
    fontSize: '1.125rem',
    lineHeight: 1.4,
  },

  // Подзаголовки (subtitles)
  subtitle1: {
    fontFamily,
    fontWeight: 500,
    fontSize: '1.5rem',
    lineHeight: 1.5,
  },
  subtitle2: {
    fontFamily,
    fontWeight: 500,
    fontSize: '1.125rem',
    lineHeight: 1.5,
  },

  // Подписи и метки
  caption: {
    fontFamily,
    fontWeight: 400,
    fontSize: '1rem',
    lineHeight: 1.2,
  },
  overline: {
    fontFamily,
    fontWeight: 500,
    fontSize: '1rem',
    lineHeight: 1.2,
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
  },

  // Кнопки
  button: {
    fontFamily,
    fontWeight: 500,
    fontSize: '1.125rem',
    lineHeight: 1.5,
    textTransform: 'none',
  },

  // Таблицы
  tableHeader: {
    fontFamily,
    fontWeight: 600,
    fontSize: '1.125rem',
    lineHeight: 1.4,
  },
  tableCell: {
    fontFamily,
    fontWeight: 400,
    fontSize: '1rem',
    lineHeight: 1.5,
  },

  // Бейджи
  badge: {
    fontFamily,
    fontWeight: 500,
    fontSize: '0.8125rem',
    lineHeight: 1.2,
  },
  badgeSmall: {
    fontFamily,
    fontWeight: 500,
    fontSize: '0.6875rem',
    lineHeight: 1.2,
  },

  // Размеры иконок (для использования в sx props)
  iconSizes: {
    xs: '1rem',      // 16px
    sm: '1.25rem',   // 20px
    md: '1.5rem',    // 24px
    lg: '2rem',      // 32px
    xl: '3rem',      // 48px
    xxl: '4rem',     // 64px
  },
};

export default typography;
